// extracted by mini-css-extract-plugin
export var root = "FooterNavigation-module--root--19da6";